export default {"src":"/_next/static/media/india.b7ea6ef3.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};